import { Popconfirm } from 'antd';
import {
  createColumnButtonArr,
  createColumnDate,
  createColumnNumber,
  createColumnTag,
  createColumnText,
  formatNumber,
  widthOptions,
} from '../../../../components/table/function';
import { WARRANTY_STATUS } from '../../../../resources/status';
import React from 'react';
import { ButtonTheme, ButtonToolTip } from '../../../../components/buttons';
import { ROUTES_PATH } from '../../../../resources/routes-name';

export const columns = ({ handleDelete }) => {
  return [
    createColumnTag(
      'สถานะ',
      { key: 'warrantyStatus', text: 'warrantyStatus', icon: true },
      WARRANTY_STATUS,
    ),
    createColumnText('เลขที่รับประกัน', 'warrantyCode', widthOptions(150)),
    createColumnText('ชื่อ-นามสกุล', 'fullName', widthOptions(150)),
    createColumnText('ชื่อไลน์', 'lineName', widthOptions(120)),
    createColumnText('เบอร์ติดต่อ', 'telephone', widthOptions(150)),
    createColumnText('รหัสสินค้า', 'itemCode', widthOptions(210)),
    createColumnText('ชื่อสินค้า', 'productName', widthOptions(150)),
    createColumnText('บาร์โค้ด', 'barcode', widthOptions(160)),
    createColumnText('QR รับประกัน', 'warrantyNumberCode', widthOptions(160)),
    createColumnText('ยี่ห้อ', 'mobileBrandName', widthOptions(100)),
    createColumnText('รุ่น', 'mobileModelName', widthOptions(150)),
    createColumnText('ช่องทางการซื้อ', 'channelBuyName', widthOptions(150)),
    createColumnDate('วันที่ลงทะเบียน', 'createDate', widthOptions(170)),
    createColumnDate('วันหมดอายุ', 'expireDate', widthOptions(150)),
    createColumnNumber(
      'วันคงเหลือ',
      'remainingDays',
      widthOptions(150, {
        render: (value) => {
          if (value > 300000) {
            return <div>ตลอดชีวิต</div>;
          } else {
            return formatNumber(value);
          }
        },
      }),
    ),
    createColumnDate('วันที่ซื้อสินค้า', 'purchaseDate', widthOptions(150)),
    createColumnButtonArr('จัดการ', 'rowNo', {
      others: {
        fixed: 'right',
        width: 170,
      },
      buttonArr: [
        {
          useFor: (record) => (record.warrantyStatus === 'CLAIMING' ? 'DETAIL' : 'EDIT3'),
          render: (_, record) => {
            if (record.warrantyStatus === 'COMPLETED') {
              return (
                <ButtonToolTip toolTip="ดูรายละเอียด">
                  <ButtonTheme
                    useFor="DETAIL"
                    onClick={() => {
                      const url = `${ROUTES_PATH.ROUTE_REGISTRATION_VIEW.PATH}?code=${record.warrantyCode}`;
                      window.open(url, '_blank');
                    }}
                  />
                </ButtonToolTip>
              );
            }
            return (
              <ButtonToolTip toolTip="แก้ไข">
                <ButtonTheme
                  useFor="EDIT2"
                  onClick={() => {
                    const url = `${ROUTES_PATH.ROUTE_REGISTRATION_EDIT.PATH}?code=${record.warrantyCode}`;
                    window.open(url, '_blank');
                  }}
                />
              </ButtonToolTip>
            );
          },
        },
        {
          useFor: 'DELETE',
          render: (_, record) => {
            if (record.warrantyStatus !== 'ACTIVE') {
              return null;
            }
            return (
              <ButtonToolTip toolTip="ยกเลิกรับประกัน" placement="topLeft">
                <Popconfirm
                  title="คุณต้องการยกเลิกการรับประกันหรือไม่?"
                  onConfirm={() => handleDelete(record)}
                  okText="ใช่"
                  cancelText="ไม่"
                >
                  <ButtonTheme useFor="DELETE" />
                </Popconfirm>
              </ButtonToolTip>
            );
          },
        },
      ],
    }),
  ];
};

export const exportHeaders = [
  { dataIndex: 'warrantyCode', title: 'เลขที่รับประกัน' },
  { dataIndex: 'warrantyNumberCode', title: 'บาร์โค้ด' },
  { dataIndex: 'categoryCode', title: 'หมวดหมู่' },
  { dataIndex: 'warrantyStatus', title: 'สถานะ' },
  { dataIndex: 'mobileBrandName', title: 'ยี่ห้อ' },
  { dataIndex: 'mobileModelName', title: 'รุ่น' },
  { dataIndex: 'itemCode', title: 'รหัสสินค้า' },
  { dataIndex: 'productName', title: 'ชื่อสินค้า' },
  { dataIndex: 'channelBuyName', title: 'ช่องทางการซื้อ' },
  { dataIndex: 'fullName', title: 'ชื่อ-นามสกุล' },
  { dataIndex: 'telephone', title: 'เบอร์โทร' },
  { dataIndex: 'email', title: 'อีเมลล์' },
  { dataIndex: 'createDate', title: 'วันที่ลงทะเบียน' },
  { dataIndex: 'claimCode', title: 'เลขที่เคลม' },
  { dataIndex: 'claimRemark', title: 'สาเหตุการเคลม' },
  { dataIndex: 'claimDate', title: 'วันที่เคลม' },
  { dataIndex: 'expireDate', title: 'วันหมดอายุ' },
  { dataIndex: 'purchaseDate', title: 'วันที่ซื้อสินค้า' },
  { dataIndex: 'warrantyStatusName', title: 'สถานะลงทะเบียน' },
  { dataIndex: 'lineUid', title: 'lineUid' },
];
